/**
 * Where the checkout reaches the API from, on both sides of the SSR boundary.
 *
 * Shared rather than duplicated: two call sites need it — the connection store the Vue app runs on,
 * and the branding lookup in `+onBeforeRender`, which runs before that store exists — and they must
 * not be able to drift apart. The `import.meta.env.SSR` guards matter because this module is
 * client-bundled too: on the client the server-only env vars do not exist, and the request goes to
 * the Hono proxy at `/api` instead, which is what attaches the app id and `x-vp-api` header.
 */

export const getApiBase = (): string | undefined => {
  const apiBase = import.meta.env.SSR ? process.env.CHECKOUT_API_URL : undefined;

  if (apiBase) {
    return apiBase;
  }

  return '/api';
};

export const getAppId = (): string | undefined => import.meta.env.SSR ? process.env.CHECKOUT_APP_ID : undefined;
